var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSignIn = function SvgSignIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m25.856 19.644.356.356-.356.356-8.5 8.5-.356.356-.706-.712.356-.356 7.644-7.644H4v-1h20.294l-7.65-7.644-.356-.356.712-.706.356.356 8.5 8.5zM24.5 33H35V7H24V6h12v28H24v-1z"
  })));
};
export default SvgSignIn;